// Note: ICON Source: https://icons.getbootstrap.com/

import variables from "../styles/utils.module.scss";

// @ts-ignore
export default function SuitabilitySummary({ match, wrapperStyle = {}, hideHeader = false }) {
  if (!match) {
    console.error(`ERR: Missing location match data`);
    return <></>;
  }

  // Not suitable response
  if (
    match?.available === 0 ||
    match?.gender === 0 ||
    match?.ageInMonths === 0 ||
    match?.filters < 100
  ) {
    return (
      <div style={{ ...wrapperStyle }}>
        {!hideHeader ? <h4 className="h5">Suitability</h4> : null}

        <div>
          {match?.available === 0 ? (
            <div>
              <i
                className={`bi bi-x-circle`}
                style={{
                  fontSize: "14px",
                  color: variables.red,
                  padding: "3px",
                  marginRight: "6px",
                }}
              ></i>
              Not available
            </div>
          ) : null}

          {match?.gender === 0 ? (
            <div>
              <i
                className={`bi bi-x-circle`}
                style={{
                  fontSize: "12px",
                  color: variables.red,
                  marginRight: "2px",
                }}
              ></i>{" "}
              Gender
            </div>
          ) : null}

          {match?.ageInMonths === 0 ? (
            <div>
              <i
                className={`bi bi-x-circle`}
                style={{
                  fontSize: "12px",
                  color: variables.red,
                  marginRight: "2px",
                }}
              ></i>{" "}
              Child age
            </div>
          ) : null}

          {match?.filters < 100 ? (
            <div>
              <i
                className={`bi bi-x-circle`}
                style={{
                  fontSize: "12px",
                  color: match?.filters < 80 ? variables.red : variables.orange,
                  marginRight: "2px",
                }}
              ></i>{" "}
              Support needs
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  if (
    match?.available === 100 &&
    match?.gender === 100 &&
    match?.ageInMonths === 100 &&
    match?.filters === 100
  ) {
    return (
      <div style={{ ...wrapperStyle }}>
        {!hideHeader ? <h4 className="h5">Suitability</h4> : null}
        <div>
          <i
            className={`bi bi-check-circle`}
            style={{
              fontSize: "14px",
              color: variables.green,
              padding: "3px",
              marginRight: "6px",
            }}
          ></i>
          All requirements match
        </div>
      </div>
    );
  }

  return <></>;
}
